import { track } from '@amplitude/analytics-browser';
import { BaseEvent } from '@amplitude/analytics-types';

export const trackEvent = (
  eventName: string | BaseEvent,
  eventProperties: Record<string, any> = {},
) => {
  track(eventName, { url: window.location.pathname, ...eventProperties });
};
